var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "input",
    _vm._b(
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue,
            expression: "innerValue",
          },
        ],
        attrs: { type: "hidden" },
        domProps: { value: _vm.innerValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.innerValue = $event.target.value
          },
        },
      },
      "input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }